export const biographyKeys = [
  'biography.age',
  'biography.father',
  'biography.piano',
  'biography.training',
  'biography.reader',
  'biography.fromArgentina',
  'biography.f1',
  'biography.mate',
];

export const linkedinUrl = 'https://www.linkedin.com/in/dario-jose-zubaray';
